import { X } from 'lucide-react';

import { Badge } from '@g17eco/ui-modern/components/ui/badge';

import { EvidenceType } from '../../types/emissions';
import { EVIDENCE_TYPE_LABEL } from '../../utils/evidenceDisplay';

interface FilterSummaryProps {
  evidenceType: EvidenceType | '';
  onClearType: () => void;
  fileType: string;
  onClearFileType: () => void;
  search: string;
  onClearSearch: () => void;
}

export const FilterSummary = ({
  evidenceType,
  onClearType,
  fileType,
  onClearFileType,
  search,
  onClearSearch,
}: FilterSummaryProps) => {
  if (!evidenceType && !fileType && !search) {
    return null;
  }
  return (
    <div className='tw:flex tw:flex-wrap tw:items-center tw:gap-2 tw:text-xs tw:text-ThemeTextMedium'>
      {evidenceType ? (
        <Badge variant='ghost' className='tw:cursor-pointer' onClick={onClearType}>
          category: {EVIDENCE_TYPE_LABEL[evidenceType]}
          <X className='tw:h-3 tw:w-3' />
        </Badge>
      ) : null}
      {fileType ? (
        <Badge variant='ghost' className='tw:cursor-pointer' onClick={onClearFileType}>
          type: {fileType}
          <X className='tw:h-3 tw:w-3' />
        </Badge>
      ) : null}
      {search ? (
        <Badge variant='ghost' className='tw:cursor-pointer' onClick={onClearSearch}>
          search: {search}
          <X className='tw:h-3 tw:w-3' />
        </Badge>
      ) : null}
    </div>
  );
};
